import script from "./ExtraInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ExtraInfo.vue?vue&type=script&setup=true&lang=js"

import "./ExtraInfo.vue?vue&type=style&index=0&id=7f554c3b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f554c3b"]])

export default __exports__